import { Collection, LongString, MaxString, ModelBase, NormalString, ObservableCollection, Property, Required, VeryLongString } from '@skylab-shared/core';
import { AddressModel } from '../address/address.model';
import { CalculationMethod } from '../common/calculation-method';
import { RelatedEntity } from '../common/related-entity';
import { DocumentBuyerModel } from '../document/document-buyer.model';
import { DocumentClientModel } from '../document/document-client.model';
import { ExchangeRateModel } from '../exchange-rate/exchange-rate.model';
import { VatTableItemModel } from '../vat-table/vat-table-item.model';
import { InventoryDocumentItemModel } from './inventory-document-item.model';
import { InventoryDocumentKind } from './inventory-document-kind';
import { InventoryRelationshipCreationMethod } from './inventory-relationship-creation-method';

export class InventoryGoodsIssueDocumentModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    @VeryLongString('data-model.inventory-document-model.validation.document-number.length')
    public documentNumber: string;

    @Property()
    public numberingId: number;

    @Property()
    public kind: InventoryDocumentKind;

    @Property(DocumentClientModel, {nullable: true})
    public client: DocumentClientModel | null;

    @Property(DocumentBuyerModel, { nullable: true })
    public buyer: DocumentBuyerModel | null;

    @Property(String, { nullable: true })
    @MaxString('data-model.document.validation.note.length')
    public note: string | null;

    @Property()
    @Required()
    public calculationMethod: CalculationMethod.Gross | CalculationMethod.Net;

    @Property()
    @Required()
    public currencyId: number;

    @Property(ExchangeRateModel, {nullable: true})
    public exchangeRate: ExchangeRateModel | null;

    @Property()
    public issueDate: Date;

    @Property()
    public goodsIssueDate: Date;

    @Property()
    public grossValue: number;

    @Property()
    public netValue: number;

    @Property()
    public issuedByVatPayer: boolean;

    @Property()
    @Required()
    public communityTransactionId: number;

    @Property({ nullable: true })
    public wstoShipmentCountryId: number;

    @Property(Number, { nullable: true })
    public wstoConsumerCountryId: number | null;

    @Property({ nullable: true })
    @MaxString('data-model.inventory-document-model.validation.wsto-additional-information.length')
    public wstoAdditionalInformation: string;

    @Property()
    @Required('data-model.inventory-document-model.validation.transaction-location.non-empty')
    @LongString('data-model.document.validation.transaction-location.length')
    public transactionLocation: string;

    @Property()
    @Required('data-model.inventory-document-model.validation.inventory.required')
    public inventoryId: number;

    @Property({nullable: true})
    @NormalString('data-model.inventory-document-model.validation.recipient.length')
    public recipient: string;

    @Property()
    public issuer: string;

    @Collection({ type: InventoryDocumentItemModel })
    public items: ObservableCollection<InventoryDocumentItemModel>;

    @Collection({ type: VatTableItemModel })
    public vatTableItems: ObservableCollection<VatTableItemModel>;

    @Collection({ type: VatTableItemModel })
    public vatTableItemsInBaseCurrency: ObservableCollection<VatTableItemModel>;

    @Property()
    public relatedCommercialDocuments: RelatedEntity[];

    @Property(AddressModel, { nullable: true })
    public deliveryAddress: AddressModel | null;

    @Property()
    public creationMethod: InventoryRelationshipCreationMethod;
}
